module.exports = __webpack_public_path__ + "img/IDA_white.9a40d419.png";